import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import depositService from "../../services/deposit.service";
import clientmanagmentObj from "../../services/client-managment.service";

/**
 * Dashboard hero band.
 *
 * Added ABOVE the existing SuperAdminDashboard content rather than replacing
 * it: that file is 457 lines with several half-commented blocks, and the
 * donut panels it renders still carry real information. This gives the
 * landing screen an identity and a work queue without touching any of it.
 *
 * The two queue counts reuse the exact service calls the nav already makes
 * (deposit.service.getDepositCounts / client-managment.getChangePinCount),
 * so no new endpoint is involved.
 */
const DashboardHero = (props) => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [depositCount, setDepositCount] = useState(null);
  const [changePinCount, setChangePinCount] = useState(null);

  useEffect(() => {
    let cancelled = false;

    depositService
      .getDepositCounts(
        "", "Pending", "0001-01-01", "0001-01-01", "0001-01-01", "0001-01-01", "", 1, ""
      )
      .then((resp) => {
        if (!cancelled) setDepositCount(resp?.data?.payload?.result?.totalCount ?? 0);
      })
      .catch(() => {
        if (!cancelled) setDepositCount(0);
      });

    clientmanagmentObj
      .getChangePinCount(
        "", "", "0001-01-01T00:00:00.000Z", "0001-01-01T00:00:00.000Z", "", 1
      )
      .then((resp) => {
        if (!cancelled) setChangePinCount(resp?.data?.payload?.result?.totalCount ?? 0);
      })
      .catch(() => {
        if (!cancelled) setChangePinCount(0);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const greeting = () => {
    const h = new Date().getHours();
    if (h < 12) return "Good morning";
    if (h < 18) return "Good afternoon";
    return "Good evening";
  };

  const firstName = (currentUser?.user?.Name || "").split(" ")[0];

  const today = new Date().toLocaleDateString(undefined, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  // A queue item only appears when it has something waiting, so the band
  // stays quiet on a clean day instead of showing a row of zeros.
  const queue = [
    {
      key: "deposit",
      label: "Deposits pending",
      count: depositCount,
      to: "/deposit",
      hint: "awaiting approval",
    },
    {
      key: "changepin",
      label: "PIN change requests",
      count: changePinCount,
      to: "/changepins",
      hint: "awaiting action",
    },
  ].filter((q) => q.count !== null && q.count > 0);

  const loading = depositCount === null && changePinCount === null;

  return (
    <Fragment>
      <section className="bopay-hero-band">
        <div className="bopay-hero-main">
          <p className="bopay-hero-eyebrow">Super Admin</p>
          <h1 className="bopay-hero-greeting">
            {greeting()}
            {firstName ? `, ${firstName}.` : "."}
          </h1>
          <p className="bopay-hero-date">{today}</p>
        </div>

        <div className="bopay-hero-queue">
          <p className="bopay-hero-queue-title">Needs attention</p>

          {loading && (
            <div className="bopay-hero-queue-empty">
              <span className="bopay-hero-skeleton" />
            </div>
          )}

          {!loading && queue.length === 0 && (
            <p className="bopay-hero-queue-clear">
              Nothing waiting. All queues are clear.
            </p>
          )}

          {!loading &&
            queue.map((q) => (
              <Link key={q.key} to={q.to} className="bopay-hero-queue-item">
                <span className="bopay-hero-queue-count">{q.count}</span>
                <span className="bopay-hero-queue-text">
                  {q.label}
                  <span className="bopay-hero-queue-hint">{q.hint}</span>
                </span>
                <span className="bopay-hero-queue-go" aria-hidden="true" />
              </Link>
            ))}
        </div>
      </section>
    </Fragment>
  );
};

export default DashboardHero;
